import React from "react"

export const icons = {
  share: {
    viewBox: "0 0 200 200",
    customCode: (
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <g fill="#FFFFFF">
            <path
              d="M100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 C200,44.771525 155.228475,0 100,0 Z M100,28.5714286 C139.448911,28.5714286 171.428571,60.5510893 171.428571,100 C171.428571,139.448911 139.448911,171.428571 100,171.428571 C60.5510893,171.428571 28.5714286,139.448911 28.5714286,100 C28.5714286,60.5510893 60.5510893,28.5714286 100,28.5714286 Z"
              fillOpacity="0.2"
              fillRule="nonzero"
              opacity="0.5"
            />
            <path d="M100.303951,69.9088146 C117.090722,69.9088146 130.699088,83.5171809 130.699088,100.303951 C130.699088,117.090722 117.090722,130.699088 100.303951,130.699088 C83.5171809,130.699088 69.9088146,117.090722 69.9088146,100.303951 C69.9088146,83.5171809 83.5171809,69.9088146 100.303951,69.9088146 Z M109.3293,88.4836204 L94.4342148,88.4836204 L94.2491696,88.4896068 C92.7810976,88.584894 91.6198503,89.8058275 91.6198503,91.2979849 L91.6198503,91.2979849 L91.6258367,91.4830302 C91.7211239,92.9511022 92.9420575,94.1123494 94.4342148,94.1123494 L94.4342148,94.1123494 L102.422684,94.1116204 L88.6179918,107.917487 L88.4808668,108.064606 C87.5209917,109.170227 87.5667001,110.846308 88.6179918,111.8976 C89.7170695,112.996677 91.4990266,112.996677 92.5981043,111.8976 L92.5981043,111.8976 L106.514684,97.9796204 L106.514936,105.487277 L106.520922,105.672322 C106.616209,107.140394 107.837143,108.301641 109.3293,108.301641 C110.883631,108.301641 112.143665,107.041607 112.143665,105.487277 L112.143665,105.487277 L112.143665,91.2979849 L112.137678,91.1129397 C112.042391,89.6448677 110.821458,88.4836204 109.3293,88.4836204 L109.3293,88.4836204 Z" />
          </g>
          <g transform="translate(50.000000, 64.000000)" />
        </g>
      </g>
    ),
  },
  g: {
    viewBox: "0 0 24 26",
    customCode: (
      <g stroke="none" fill="none" fillRule="evenodd">
        <g
          transform="translate(-22.000000, -17.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path d="M35.3489051,42.3333333 C27.7109489,42.3333333 22,37.1135531 22,29.7362637 L22,29.6666667 C22,22.5677656 27.6058394,17 35.2087591,17 C39.5182482,17 42.5664234,18.3223443 45.1591241,20.5494505 L41.1649635,25.3168498 C39.4131387,23.8553114 37.6613139,23.0201465 35.2437956,23.0201465 C31.7051095,23.0201465 28.9722628,25.978022 28.9722628,29.7014652 L28.9722628,29.7710623 C28.9722628,33.7032967 31.740146,36.521978 35.6291971,36.521978 C37.2759124,36.521978 38.5372263,36.1739927 39.5532847,35.5128205 L39.5532847,32.5549451 L34.7182482,32.5549451 L34.7182482,27.6135531 L46,27.6135531 L46,38.5750916 C43.4072993,40.6978022 39.7985401,42.3333333 35.3489051,42.3333333 Z" />
        </g>
      </g>
    ),
  },

  burger: {
    viewBox: "0 0 33.53 24.11",
    customCode: (
      <g fill="currentColor">
        <path d="M31.53,4H2A2,2,0,0,1,2,0H31.53a2,2,0,0,1,0,4Z" />
        <path d="M31.53,14.06H2a2,2,0,0,1,0-4H31.53a2,2,0,0,1,0,4Z" />
        <path d="M31.53,24.11H2a2,2,0,0,1,0-4H31.53a2,2,0,0,1,0,4Z" />
      </g>
    ),
  },

  close: {
    viewBox: "0 0 24.98 24.98",
    customCode: (
      <g fill="currentColor">
        <path d="M23,25a2,2,0,0,1-1.41-.58L11.08,13.91a2,2,0,0,1,2.83-2.83L24.4,21.57A2,2,0,0,1,23,25Z" />
        <path d="M7.1,9.1a2,2,0,0,1-1.41-.58L.59,3.41A2,2,0,0,1,.59.59a2,2,0,0,1,2.82,0l5.11,5.1A2,2,0,0,1,7.1,9.1Z" />
        <path d="M2,25A2,2,0,0,1,.59,21.57l21-21A2,2,0,0,1,24.4,3.41l-21,21A2,2,0,0,1,2,25Z" />
      </g>
    ),
  },
}
